import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import heroImg from '../img/hero/banner.webp';
import getBlogData from '../helpers/blogData';
import './Blog.css';

const Blog = () => {
  const { t } = useTranslation('blog');
  const articles = getBlogData();

  return (
    <>
      <div className="header__banner-wrapper">
        <Helmet>
          <title>{t('helmet.title')}</title>
          <meta name="description" content={t('helmet.description')} />
          <meta name="keywords" content={t('helmet.keywords')} />
          <link rel="canonical" href="https://jetpeel.fi/blog" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={t('helmet.title')} />
          <meta property="og:description" content={t('helmet.description')} />
          <meta property="og:url" content="https://jetpeel.fi/blog" />
          <meta
            property="og:image"
            content="https://jetpeel.fi/img/og-image.jpg"
          />
        </Helmet>

        <img
          loading="lazy"
          className="header__banner"
          src={heroImg}
          alt="JetPeel blog"
        />
      </div>
      <div className="blog-hero__content">
        <p className="blog-hero__label">JetPeel</p>
        <h1 className="title-1">{t('page.title')}</h1>
        <p className="blog-hero__subtitle">{t('page.subtitle')}</p>
      </div>

      <div className="blog-list">
        <div className="container">
          <div className="blog-list__grid">
            {articles.map((article) => (
              <Link
                key={article.slug}
                to={`/blog/${article.slug}`}
                className="blog-card"
              >
                <div className="blog-card__img">
                  <img
                    src={article.images.card}
                    alt={article.title}
                    loading="lazy"
                  />
                </div>
                <div className="blog-card__body">
                  <p className="blog-card__meta">
                    {article.date} &nbsp;·&nbsp; {article.readTime}
                  </p>
                  <h2 className="blog-card__title">{article.title}</h2>
                  <p className="blog-card__excerpt">{article.excerpt}</p>
                  <span className="blog-card__more">
                    {t('page.readMore')} →
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog;
